<div class="actions" [ngSwitch]="variant">
    <!-- Simple template start -->
    <ng-container *ngSwitchCase="'simple'">
        <button
            class="kk-btn kk-btn_small button-add kk-overflow-ellipsis"
            [disabled]="!line.inStock && !isNotifyMeEnabled"
            (click)="line.inStock ? addToBasket() : notifyMe()"
            [ngClass]="[state | async]"
            [class.reserve-btn]="!line.inStock && isNotifyMeEnabled"
        >
            <ng-container [ngSwitch]="state | async">
                <ng-container *ngSwitchCase="'idle'">
                    <span>{{ ((line.activeSplashes | isPreOrder) ? 'general.action.preOrderBasket' : (line.inStock || !isNotifyMeEnabled ? 'general.action.addToBasket' : 'general.action.notifyMe')) | translateSafe }}</span>
                </ng-container>
                <app-loading-dots *ngSwitchCase="'loading'"></app-loading-dots>
                <span *ngSwitchCase="'success'">{{ 'general.feedback.addToBasketSuccess' | translateSafe }}</span>
                <ng-container *ngSwitchCase="'error'">
                    <app-svg-icon iconName="error"></app-svg-icon>
                    <span>{{ 'general.feedback.addToBasketError' | translateSafe }}</span>
                </ng-container>
            </ng-container>
        </button>

        <button
            class="kk-btn kk-btn_secondary kk-btn_small kk-overflow-ellipsis"
            [disabled]="!(line | productReservable)"
            *ngIf="storesService.favoriteStore$ | async; else reserveChooseStore"
            (click)="openStockOverlay('checkout')"
        >
            {{ 'stock.buttons.reserve' | translateSafe }}
        </button>
        <ng-template #reserveChooseStore>
            <button
                class="kk-btn kk-btn_secondary kk-btn_small kk-overflow-ellipsis"
                [disabled]="!(line | productReservable)"
                (click)="openStockOverlay('reserve')"
            >
                {{ 'stock.buttons.reserve' | translateSafe }}
            </button>
        </ng-template>
    </ng-container>
    <!-- Simple template end -->

    <!-- Normal template start -->
    <ng-container *ngSwitchCase="'normal'">
        <button
            class="kk-btn button-add button-add-normal kk-btn_svg kk-overflow-ellipsis"
            [disabled]="!line.inStock && !isNotifyMeEnabled"
            (click)="line.inStock ? addToBasket() : notifyMe()"
            [ngClass]="[state | async]"
            [class.reserve-btn]="!line.inStock && isNotifyMeEnabled"
            *ngIf="isNotifyMeEnabled ? true : line.stockQuantity > 0"
        >
            <ng-container [ngSwitch]="state | async">
                <ng-container *ngSwitchCase="'idle'">
                    <app-svg-icon *ngIf="isNotifyMeEnabled ? false : line.stockQuantity > 0"
                                  iconName="basket"></app-svg-icon>
                    <span>{{ ((line.activeSplashes | isPreOrder) ? 'general.action.preOrderBasket' : (line.inStock || !isNotifyMeEnabled ? 'general.action.addToBasket' : 'general.action.notifyMe')) | translateSafe }}</span>
                </ng-container>
                <app-loading-dots *ngSwitchCase="'loading'"></app-loading-dots>
                <span *ngSwitchCase="'success'">{{ 'general.feedback.addToBasketSuccess' | translateSafe }}</span>
                <ng-container *ngSwitchCase="'error'">
                    <app-svg-icon iconName="error"></app-svg-icon>
                    <span>{{ 'general.feedback.addToBasketError' | translateSafe }}</span>
                </ng-container>
            </ng-container>
        </button>

        <button
            class="kk-btn kk-btn_secondary button-less-precedence button-normal kk-overflow-ellipsis"
            [disabled]="!(line | productReservable)"
            *ngIf="storesService.favoriteStore$ | async; else reserveChooseStore"
            (click)="openStockOverlay('checkout')"
        >
            {{ 'stock.buttons.reserve' | translateSafe }}
        </button>
        <ng-template #reserveChooseStore>
            <button
                class="kk-btn kk-btn_secondary button-less-precedence button-normal kk-overflow-ellipsis"
                [disabled]="!(line | productReservable)"
                (click)="openStockOverlay('reserve')"
            >
                {{ 'stock.buttons.reserve' | translateSafe }}
            </button>
        </ng-template>

        <ng-container *ngIf="(line?.activeCampaigns | getCampaignType: 'Mixed') as campaign">
            <ng-container *ngIf="campaignState | async as state">
                <button *ngIf="(line.activeSplashes | getPrioritySplash) as splash"
                        [ngClass]="[campaignState | async]"
                        class="kk-btn kk-btn_blue kk-btn_full-width kk-btn_svg kk-overflow-ellipsis button-campaign"
                        type="button"
                        (click)="openCampaignOverlay(campaign)"
                >
                    <span *ngIf="state === 'idle'" [innerHTML]="splash?.text"></span>
                    <app-svg-icon *ngIf="state === 'idle'" aria-hidden="true" iconName="arrow_right"></app-svg-icon>
                    <app-loading-dots *ngIf="state === 'loading'"></app-loading-dots>
                </button>
            </ng-container>
        </ng-container>

        <p class="product-unavailable" *ngIf="!(line | productAvailable) && variant === 'normal'">
            {{ 'stock.cantBuyOrReserve' | translateSafe }}
        </p>
    </ng-container>

    <!-- Normal template end -->
</div>
